import jyRequest from "../utils/axios";

export function login(data){
  return jyRequest.post({
    url:'api/sys/login',
    data: data,
  })
}

export function register(data){
  return jyRequest.post({
    url:'api/sys/register',
    data: data,
  })
}

export function logout(data){
  return jyRequest.post({
    url:'api/sys/logout',
    data: data,
    headers:{
      Authorization:JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}